export default __webpack_public_path__ + "static/media/crewMembertoggler.a009ffdf.svg";